import {GeneralLayout} from '@dynamynd/dynamynd';
import {createNavigator, SwitchRouter} from '@react-navigation/core';
import {appView} from '../core/AppView/AppView';
import {routes} from '../core/routes';

export const appNavigator = createNavigator(appView(GeneralLayout), SwitchRouter(routes), {});
